import { useHeaderStore } from '@/store/headerStore';
import { useConfigStore } from '@/store/configStore';
import { useEffect, useState } from 'react';
import { applyThemeColor } from '@/utils/utils';

export const useDarkMode = () => {
  const { setGradient } = useHeaderStore();
  const { config } = useConfigStore();
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    const root = document.documentElement;

    if (isDarkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    if (config?.themeColor) {
      applyThemeColor(config.themeColor, isDarkMode);
    }

    setGradient(isDarkMode);
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  }, [isDarkMode, config?.themeColor, setGradient]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return { isDarkMode, toggleDarkMode };
};
